// extracted by mini-css-extract-plugin
export default {"newProject_container":"Motivo_newProject_container__miZeL"};